import { useMemo } from 'react'
import { GraphQL } from '@guestgoodie/graphql'
import { useLingui } from '@lingui/react/macro'

export function amount(order: GraphQL.OrderFragmentFragment) {
  switch (order.__typename) {
    case 'OrderEvent':
      return order.event.amount
    case 'OrderDefault':
      return order.default.amount
  }
}

export function startDate(order: GraphQL.OrderFragmentFragment) {
  switch (order.__typename) {
    case 'OrderEvent':
      return order.event.eventOccurence.startAt
    case 'OrderDefault':
      return order.default.start
  }
}

export function unitPrice(order: GraphQL.OrderFragmentFragment) {
  switch (order.__typename) {
    case 'OrderEvent':
      return order.event.seatPrice
    case 'OrderDefault':
      return order.default.unitPrice
  }
}

export function useStateToLabel() {
  const { t } = useLingui()

  return useMemo(() => {
    return {
      [GraphQL.OrderState.Approved]: t`Approved`,
      [GraphQL.OrderState.Rejected]: t`Rejected`,
      [GraphQL.OrderState.Cancelled]: t`Cancelled by customer`,
      [GraphQL.OrderState.Pending]: t`Pending`
    }
  }, [t])
}
